// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//
// NOTE: when adding new page type constants here, you also *must* add them to
// util/ga.js so that pageviews don't get content group set to 'Not Set'.
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
module.exports = {
  HOME: 'home',
  AUTHOR: 'author',
  ARCHIVE: 'archive',
  CATEGORY: 'category',
  HOMEMADE: 'homemade',
  FEATURE: 'feature',
  PAGE: 'page',
  POST: 'post',
  COLLECTION: 'collection',
  ERROR_NOT_FOUND: 'error404',
  ERROR_GENERIC: 'error',
  PREVIEW: 'preview',
  EMAIL: 'email',
  SEARCH: 'search',
  ACCOUNT: 'account',
  SAVED_STORIES: 'savedStories',
  VISION_BOARDS: 'visionBoards',
  VISION_BOARD: 'visionBoard',
  PRISM_IMAGE: 'prismImage',
  PRISM_COLOR: 'prismColor',
  PRISM_TAG: 'prismTag',
  SITEMAP: 'sitemap',
  TEAM: 'team',
  AUTHENTICATION: 'authentication',
  ESSENTIAL_PRODUCTS: 'essentialProducts',
  FAQ: 'faq',
  CONTEST: 'contest',
  SUBMISSION: 'submission',
  STATIC_PRISM_PAGE: 'staticPrismPage',
  SMALL_COOL_EXPERIENCE: 'smallCoolExperience',
  IMAGE_COLLECTION: 'imageCollection',
  RECIPE_BOX: 'recipeBox'
};
